export default __webpack_public_path__ + "static/developer-3d9bb53701fcb43a841d4280b3e6a0cb.png";